import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TSngZorroAntdModule } from './tsng-zorro-antd/tsng-zorro-antd.module';
import { NZ_I18N, NZ_DATE_LOCALE, it_IT } from 'ng-zorro-antd/i18n';
import { it } from 'date-fns/locale';
import { GetIdentityDisplayStatusPipe, GetIdentityTypeDisplayPipe } from 'src/app/identity/identity.model';
import { ModifyPasswordComponent } from './modify-password/modify-password.component';
import { ErcLostModalComponentComponent } from 'src/app/shared/erc-lost-modal-component/erc-lost-modal-component.component';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { ResendOtpComponent } from './resend-otp/resend-otp.component';
import { SearchComponent } from './search/search.component';
import { Ng2TelInputModule } from '../ng2-tel-input/ng2-tel-input.module';
import { AutoFocusDirective } from './auto-focus.directive';


@NgModule({
  declarations: [
    GetIdentityDisplayStatusPipe,
    GetIdentityTypeDisplayPipe,
    ModifyPasswordComponent,
    ErcLostModalComponentComponent,
    ResendOtpComponent,
    SearchComponent,
    AutoFocusDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TSngZorroAntdModule,
    Ng2TelInputModule,
    NzProgressModule
  ],
  exports: [
    TSngZorroAntdModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GetIdentityDisplayStatusPipe,
    GetIdentityTypeDisplayPipe,
    ModifyPasswordComponent,
    ErcLostModalComponentComponent,
    Ng2TelInputModule,
    NzProgressModule,
    ResendOtpComponent,
    SearchComponent,
    AutoFocusDirective
  ],
  providers: [
    { provide: NZ_I18N, useValue: it_IT },
    { provide: NZ_DATE_LOCALE, useValue: it},
  ]
})
export class SharedModule { }
